import fs from 'fs';
/**
 * Get the SYDLE UI configuration from the package.json file.
 * @param packageJsonPath The path to the package.json file.
 * @returns The SYDLE UI configuration.
 */
export function getPackageConfig(packageJsonPath) {
    var _a;
    if (!fs.existsSync(packageJsonPath)) {
        return null;
    }
    const jsonContent = fs.readFileSync(packageJsonPath, 'utf-8');
    const packageJson = JSON.parse(jsonContent);
    return (_a = packageJson === null || packageJson === void 0 ? void 0 : packageJson['sydle-ui']) !== null && _a !== void 0 ? _a : null;
}
